<ng-container *ngIf='!inputService.hidden && inputService.formInputDefinition && show'>
	<div class='info-field readonly-field'>
		<span class='info-head' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.computedTitle | translate}}</span>
		<br>
		<span *ngIf='!loading' class='info-value'> {{computedValue}} </span>
	</div>
</ng-container>